import { InvoiceType } from '../stores/models/InvoiceType';
import { ContentType } from '../stores/models/ContentType';

export function formatAsCurrency(value: number, maximumFractionDigits: number = 2): string {
  return value != null ? value.toLocaleString('et-ET', { style: 'currency', currency: 'EUR', maximumFractionDigits: maximumFractionDigits }) : null;
}

export function trim(value: string): string {
  return value ? value.trim() : '';
}

export function formatAsNumberWithTwoDecimalPlaces(value: number): number {
  return Number(value.toFixed(2));
}

export function parseInvoiceType(contentType: ContentType, customerType: string): InvoiceType {
  if (contentType === 'MOBILE') {
    return InvoiceType.MOBILE;
  }
  if (contentType === 'BROADBAND' && customerType === 'B2B') {
    return InvoiceType.BUSINESS;
  }
  if (contentType === 'STATE_FEES') {
    return InvoiceType.STATE_FEES;
  }
  if (contentType === 'DEBT') {
    return InvoiceType.DEBT;
  }
  if (contentType === 'TELESERVICES') {
    return InvoiceType.TELESERVICES;
  }
  if (contentType === 'PENALTY') {
    return InvoiceType.PENALTY;
  }
  if (contentType === 'GOODS') {
    return InvoiceType.GOODS;
  }
  return InvoiceType.GOODS;
}

export function invoiceIconName(invoiceType: ContentType): string {
  switch (invoiceType) {
    case 'MOBILE':
      return '#phone';
    case 'GOODS':
    case 'STATE_FEES':
    case 'FINANCE':
    case 'DEBT':
    case 'TELESERVICES':
    case 'PENALTY':
    default:
      return '#file-bill';
  }
}
